import { request as https, requestPost } from "./request";
import { baseUrl } from './userRequest';

export const priceActionRequest = (params) => {  
  return requestPost.post(`${baseUrl}/PriceAction`, params);
};

export const PriceIndexRequest = (params) => {  
  return https.get(`${baseUrl}/index`, params);
};

export const vdrMediaGroupRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRMediaLevel`, params);
};

export const vdrGroupRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDR_Asas`, params);
};

export const vdrForensicRequest = (params) => {  
  return requestPost.post(`${baseUrl}/forensic`, params);
};

export const vdrFavoriteRequest = (params) => {  
  return requestPost.post(`${baseUrl}/Favorites`, params);
};

export const vdrCompanyRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRCompany_Asas`, params);
};

export const vdrAssignEmployeeRequest = (params) => {  
  return requestPost.post(`${baseUrl}/AssignCompanyToEmployees`, params);
};

export const vdrMediaRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRMedia`, params);
};
 
export const vdrLevelRequest = () => {  
  return requestPost.post(`${baseUrl}/VDRlevelmaster`);
};
 
export const vdrSortDataRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRCompanySorting_Asas`, params);
};
 
export const vdrSortDataUpdateRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRCompanySortingUpdate_Asas`, params);
};
 
export const vdrEmployeeRequest = (params) => {  
  return requestPost.post(`${baseUrl}/EmployeeMaster`, params);
};
 
export const vdrHomeRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRHome_Asas`, params);
};
 
export const vdrHomeCompaniesRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRHome`, params);
};
 
export const filesLogRequest = (params) => {  
  return requestPost.post(`https://omkaracapital.in/api/files-logs`, params);
};
 
export const vdrImageUploadRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRFileUploader`, params);
};
 
 
export const vdrSingleCompanyRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDRDataRoom`, params);
};
 
 
 
export const vdrMediaDataRequest = (params) => {  
  return requestPost.post(`${baseUrl}/media`, params);
};
 
 
export const vdrData20YearsRequest = (params) => {  
  return requestPost.post(`${baseUrl}/Data20YearsSingleCompany`, params);
};
 
export const vdrPeerToPeerRequest = (params) => {  
  return requestPost.post(`${baseUrl}/PeerToPeer`, params);
};
 
export const vdrSegmentRequest = (params) => {  
  return requestPost.post(`${baseUrl}/VDR_Segments_Add`, params);
};
 
export const vdrSegmentAssignRequest = (params) => {  
  return requestPost.post(`${baseUrl}/AssignSegmenttogroup`, params);
};

 
export const quarterlyReviewRequest = (params) => {
  return requestPost.post(`${baseUrl}/ResultOverView`, params);
};

 
export const quarterlySegmentRequest = (params) => {
  return requestPost.post(`${baseUrl}/QtrSegment`, params);
};
 

export const quarterlySegmentStandaloneRequest = (params) => {
  return requestPost.post(`${baseUrl}/QtrSegmentStandalone`, params);
};


export const geoLocationDb = (params) => {  
  return requestPost.post(`https://geolocation-db.com/json/`, params);
};


export const DateAPI = () => {
  return https.get(`${baseUrl}/DateAPI`);
};